import { useEffect, useState } from 'react';

const EMPTY = {
  idPersona: 0,
  numero: '',
  tipo: 'Móvil',
  esPrincipal: true,
};

export default function Modal({
  open,
  mode = 'new',
  data = null,
  fkValue = 0,
  onClose,
  onSubmit,
  inline = false,
}) {
  EMPTY.idPersona = fkValue;
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({
    numero: '',
    tipo: '',
  });

  const validateField = (field, rawValue) => {
    const value = typeof rawValue === 'string' ? rawValue.trim() : rawValue;
    let error = '';

    switch (field) {
      case 'numero':
        if (!value) error = 'Captura el número de teléfono.';
        break;
      case 'tipo':
        if (!value) error = 'Selecciona el tipo de teléfono.';
        break;
      default:
        break;
    }

    setErrors((prev) => ({
      ...prev,
      [field]: error,
    }));

    return !error;
  };

  const validateAll = () => {
    const okNum = validateField('numero', form.numero);
    const okTipo = validateField('tipo', form.tipo);
    return okNum && okTipo;
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
    if (field !== 'esPrincipal') {
      validateField(field, value);
    }
  };

  useEffect(() => {
    if (mode === 'edit' && data) {
      const filled = {
        idPersona: data.idPersona ?? fkValue ?? 0,
        numero: data.numero ?? '',
        tipo: data.tipo ?? 'Móvil',
        esPrincipal: !!data.esPrincipal,
      };
      setForm(filled);
      validateField('numero', filled.numero);
      validateField('tipo', filled.tipo);
    } else {
      setForm({
        ...EMPTY,
        idPersona: fkValue,
      });
      setErrors({ numero: '', tipo: '' });
    }
  }, [mode, data, fkValue]);

  const isSaveDisabled =
    !form.numero?.trim() ||
    !form.tipo?.trim() ||
    !!errors.numero ||
    !!errors.tipo;

  const errorStyle = {
    color: '#b91c1c',
    fontSize: '.8rem',
    display: 'block',
    marginTop: '.25rem',
  };

  if (!open) return null;

  const Header = (
    <div
      className="roles-topbar"
      style={{
        marginBottom: '0.6rem',
        paddingRight: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: '0 0 auto',
      }}>
      <h3 className="roles-title" style={{ marginRight: 0 }}>
        {mode === 'new' ? 'Nuevo teléfono' : 'Editar teléfono'}
      </h3>
      <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
    </div>
  );

  const Body = (
    <div
      style={{
        paddingLeft: '15%',
        paddingRight: 16,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.8rem',
        overflowY: 'auto',
        flex: '1 1 auto',
        minHeight: 0,
      }}>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Teléfono:</label>
        <br /><br />
        <input
          className={`infoField${errors.numero ? ' infoField--error' : ''}`}
          value={form.numero}
          onChange={(e) => handleChange('numero', e.target.value)}
          maxLength={30}
        />
        {errors.numero && <small style={errorStyle}>{errors.numero}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Tipo:</label>
        <br /><br />
        <select
          className={`infoField${errors.tipo ? ' infoField--error' : ''}`}
          value={form.tipo}
          onChange={(e) => handleChange('tipo', e.target.value)}
        >
          <option value="Móvil">Móvil</option>
          <option value="Casa">Casa</option>
          <option value="Trabajo">Trabajo</option>
          <option value="Empresa">Empresa</option>
          <option value="Emergencia">Emergencia</option>
        </select>
        {errors.tipo && <small style={errorStyle}>{errors.tipo}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem', display: 'block', marginBottom: '8px' }}>Principal:</label>
        <div
          onClick={() => handleChange('esPrincipal', !form.esPrincipal)}
          style={{
            width: '38px',
            height: '20px',
            backgroundColor: form.esPrincipal ? '#10b981' : '#cbd5e1',
            borderRadius: '12px',
            position: 'relative',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            flexShrink: 0,
            margin: '0'
          }}
          title={form.esPrincipal ? "Desactivar principal" : "Marcar como principal"}
        >
          <div style={{
            width: '14px',
            height: '14px',
            backgroundColor: 'white',
            borderRadius: '50%',
            position: 'absolute',
            top: '3px',
            left: form.esPrincipal ? '21px' : '3px',
            transition: 'left 0.2s',
            boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
          }} />
        </div>
      </div>
    </div>
  );

  const Footer = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '.6rem',
        marginTop: '.8rem',
        paddingRight: 16,
        flex: '0 0 auto',
      }}
    >
      <button className="roles-btn" onClick={onClose}>Cancelar</button>
      <button
        className="btn-action"
        onClick={() => {
          if (!validateAll()) return;
          onSubmit(form, mode);
        }}
        disabled={isSaveDisabled}
        style={{
          opacity: isSaveDisabled ? 0.5 : 1,
          cursor: isSaveDisabled ? 'not-allowed' : 'pointer',
        }}
      >
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  if (inline) {
    return (
      <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {Header}
        {Body}
        {Footer}
      </div>
    );
  }

  return (
    <div
      className="roles-confirm-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 1000,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div
        className="roles-confirm-card"
        style={{
          width: 'min(720px, 96vw)',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {Header}
        {Body}
        {Footer}
      </div>
    </div>
  );
}
